import Vue from 'vue';
import { MtButtonPlugin, MtCenterBlockPlugin } from '@mt/ui';
import '@/styles/main.css';
import App from './App.vue';
import { MetrixPlugin } from './plugins/MetrixPlugin';
import { createI18n } from './i18n/plugin';
import { messages } from './i18n/messages';

window.VUE_APP_MODE = process.env.VUE_APP_MODE;
window.VUE_APP_BUILD_NUMBER = process.env.VUE_APP_BUILD_NUMBER;
window.VUE_APP_ENVIRONMENT = process.env.VUE_APP_ENVIRONMENT;
window.VUE_APP_BRANCH = process.env.VUE_APP_BRANCH;

Vue.config.productionTip = false;

Vue.use(MtButtonPlugin);
Vue.use(MtCenterBlockPlugin);
Vue.use(MetrixPlugin);

new Vue({
    i18n: createI18n({ messages }),
    render: (h) => h(App),
}).$mount('#app');
